var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"membership",attrs:{"id":"wrap"}},[_c('section',{staticClass:"login_wrap"},[_c('div',{staticClass:"table_box"},[_c('div',{staticClass:"out_layer_box"},[_c('div',{staticClass:"in_layer_box"},[_c('Nuxt')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }